import { View, Text, SafeAreaView, ScrollView } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { TitlesEarned } from "../../components/TitlesEarned";

// Preview-only fake dog used to spec out what a high-FCAT profile would look like.
// Not linked from anywhere — only reachable by direct URL.
const FAKE_STATS: any = {
  totalRuns: 1280,
  totalPoints: 100500, // FCAT200 threshold = 1000 + 199*500 = 100,500
  averageSpeed: 28.4,
  bestThreeAvgSpeed: 31.2,
  personalBestSpeed: 32.7,
  personalBestTime: 6.26,
  personalBestPoints: 49.05,
  currentTitle: "FCAT200",
  nextTitle: "FCAT201",
  pointsToNextTitle: 500,
  run1AvgSpeed: 27.8,
  run2AvgSpeed: 28.9,
  run1Count: 640,
  run2Count: 640,
};

export default function FCAT200Preview() {
  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "#F4F6F8" }}>
      <ScrollView contentContainerStyle={{ padding: 20, paddingBottom: 60 }}>
        {/* Preview banner */}
        <View style={{ backgroundColor: "#FEF3C7", borderLeftWidth: 4, borderLeftColor: "#F59E0B", padding: 14, borderRadius: 10, marginBottom: 16 }}>
          <View style={{ flexDirection: "row", alignItems: "center", gap: 8, marginBottom: 4 }}>
            <Ionicons name="eye-outline" size={16} color="#92400e" />
            <Text style={{ fontSize: 12, fontWeight: "800", color: "#92400e", letterSpacing: 1, textTransform: "uppercase" }}>Preview Only</Text>
          </View>
          <Text style={{ fontSize: 13, color: "#92400e", lineHeight: 18 }}>
            Mock profile showing how the Titles Earned section will look for a dog at FCAT200. Not real data.
          </Text>
        </View>

        {/* Dog header card */}
        <View style={{ backgroundColor: "#1B2A4A", borderRadius: 16, padding: 20, marginBottom: 20 }}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <View style={{ width: 68, height: 68, borderRadius: 34, backgroundColor: "rgba(255,255,255,0.15)", alignItems: "center", justifyContent: "center", marginRight: 14, borderWidth: 2, borderColor: "#F5A623" }}>
              <Ionicons name="trophy" size={36} color="#F5A623" />
            </View>
            <View style={{ flex: 1 }}>
              <Text style={{ color: "#fff", fontSize: 22, fontWeight: "800" }}>Demo Champion</Text>
              <Text style={{ color: "#94A3B8", fontSize: 13, marginTop: 2 }}>Boxer · Female</Text>
              <View style={{ flexDirection: "row", gap: 6, marginTop: 6 }}>
                <View style={{ backgroundColor: "#F5A623", paddingHorizontal: 7, paddingVertical: 2, borderRadius: 5 }}>
                  <Text style={{ fontSize: 10, fontWeight: "900", color: "#1B2A4A" }}>FCAT200</Text>
                </View>
                <View style={{ backgroundColor: "rgba(255,255,255,0.15)", paddingHorizontal: 7, paddingVertical: 2, borderRadius: 5 }}>
                  <Text style={{ fontSize: 10, fontWeight: "700", color: "#fff" }}>1,280 runs</Text>
                </View>
                <View style={{ backgroundColor: "rgba(255,255,255,0.15)", paddingHorizontal: 7, paddingVertical: 2, borderRadius: 5 }}>
                  <Text style={{ fontSize: 10, fontWeight: "700", color: "#fff" }}>32.70 mph</Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        {/* Titles Earned at FCAT200 */}
        <TitlesEarned stats={FAKE_STATS} />

        {/* Variations for comparison */}
        <Text style={{ fontSize: 12, fontWeight: "700", color: "#6b7280", marginTop: 24, marginBottom: 8, letterSpacing: 1, textTransform: "uppercase" }}>
          Compare — Lower Tiers
        </Text>

        <Text style={{ fontSize: 13, color: "#374151", marginBottom: 6 }}>At FCAT50 (Champion):</Text>
        <TitlesEarned stats={{ ...FAKE_STATS, totalPoints: 25500, currentTitle: "FCAT50" }} />

        <Text style={{ fontSize: 13, color: "#374151", marginBottom: 6, marginTop: 8 }}>At FCAT25 (Elite):</Text>
        <TitlesEarned stats={{ ...FAKE_STATS, totalPoints: 13000, currentTitle: "FCAT25" }} />

        <Text style={{ fontSize: 13, color: "#374151", marginBottom: 6, marginTop: 8 }}>At FCAT10 (current ceiling):</Text>
        <TitlesEarned stats={{ ...FAKE_STATS, totalPoints: 5500, currentTitle: "FCAT10" }} />
      </ScrollView>
    </SafeAreaView>
  );
}
